import React, { useEffect } from 'react';
import './App.css';
import PartnerRoutes from './routing/masterrouting';
import GlobalStyle from './GlobalStyle';
import { registerPushSubscription } from './pushManager';
import { useSessionManager } from './hooks/useSessionManager';
function App() {
  useSessionManager();

  useEffect(() => {
    registerPushSubscription(); // Register push notifications when the component mounts
  }, []);
  return (
    <>
      <GlobalStyle />
      <PartnerRoutes />
    </>


  );
}

export default App;
